import { DeploymentStatus } from "../../common/models/DeploymentStatus";
import { ModelFactory } from "../../ModelFactory";

export class Entity {
  constructor(
    public readonly id: string,
    public readonly customerId: string,
    public readonly customerName: string,
    public readonly type: string,
    public readonly status: DeploymentStatus,
    public readonly displayName: string,
    public readonly properties: object,
    public readonly createdAt: Date,
    public readonly updatedAt: Date,
  ) {
  }
}

class EntityFactory extends ModelFactory<Entity> {
  protected fromJson(json: any): Entity {
    return new Entity(
      json['id'],
      json['customer']['id'],
      json['customer']['name'],
      json['type'],
      json['status'],
      json['display_name'],
      json['properties'],
      new Date(json['created_at']),
      new Date(json['updated_at']),
    );
  }
}
export const entityFactory = new EntityFactory();
